import { useTranslation } from 'react-i18next';

export default function PassingThroughGateSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-b from-background-50 via-background-100/30 to-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {/* Title */}
        <div className="text-center mb-10">
          <h2
            className="text-2xl md:text-3xl text-foreground-900 mb-2"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {t('journey.passingThrough.title')}
          </h2>
          <p className="text-sm text-foreground-400 italic">
            {t('journey.passingThrough.titleEn')}
          </p>
        </div>

        {/* Steps — vertical flow with arrows */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-10">
          {/* Step 1 */}
          <div className="flex flex-col items-center text-center flex-1 max-w-[200px]">
            <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-3">
              <span className="text-primary-600 text-sm font-semibold">1</span>
            </div>
            <p className="text-sm text-foreground-700 leading-snug mb-1">
              {t('journey.passingThrough.step1')}
            </p>
            <p className="text-[11px] text-foreground-400">
              {t('journey.passingThrough.step1En')}
            </p>
          </div>

          {/* Arrow */}
          <div className="text-foreground-300 text-lg hidden md:block">→</div>
          <div className="text-foreground-300 text-lg md:hidden">↓</div>

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center flex-1 max-w-[200px]">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
              <span className="text-accent-600 text-sm font-semibold">2</span>
            </div>
            <p className="text-sm text-foreground-700 leading-snug mb-1">
              {t('journey.passingThrough.step2')}
            </p>
            <p className="text-[11px] text-foreground-400">
              {t('journey.passingThrough.step2En')}
            </p>
          </div>

          {/* Arrow */}
          <div className="text-foreground-300 text-lg hidden md:block">→</div>
          <div className="text-foreground-300 text-lg md:hidden">↓</div>

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center flex-1 max-w-[200px]">
            <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
              <span className="text-secondary-600 text-sm font-semibold">3</span>
            </div>
            <p className="text-sm text-foreground-700 leading-snug mb-1">
              {t('journey.passingThrough.step3')}
            </p>
            <p className="text-[11px] text-foreground-400">
              {t('journey.passingThrough.step3En')}
            </p>
          </div>
        </div>

        {/* Revelation — the core statement */}
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-block bg-background-50 border border-secondary-200/70 rounded-xl px-6 py-4">
            <p className="text-sm md:text-base text-foreground-800 leading-relaxed mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('journey.passingThrough.revelation')}
            </p>
            <p className="text-xs text-foreground-400 italic">
              {t('journey.passingThrough.revelationEn')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}